import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./SimilarDoctors.css";
import { useNavigate } from "react-router-dom";
import DoctorCard from "../../../common-components/doctor_card/DoctorCard";
import { useDispatch, useSelector } from "react-redux";
import { getAllSimilarDoctors } from "../../../../features/doctor/doctorSlice";

function SimilarDoctors({ user_id, category_id }) {
  const navigate = useNavigate();
  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleToggle = () => {
    navigate("/categories");
  };
  const data = [
    {
      id: 1,
      image: "/assets/images/home/dr/img1.png",
      category: "Ayurvedic",
      name: "Dr. Amit Sharma",
      hospital: "City Care Hospital, Pune",
      price: "908",
    },
    {
      id: 2,
      image: "/assets/images/home/dr/img2.png",
      category: "Homeopathy",
      name: "Dr. Aditya Jagtap",
      hospital: "Healing Touch Clinic, Mumbai",
      price: "1090",
    },
    {
      id: 3,
      image: "/assets/images/home/dr/img3.png",
      category: "General Physician",
      name: "Dr. Sakshi Awhad",
      hospital: "LifeCare Hospital, Delhi",
      price: "833",
    },
    {
      id: 4,
      image: "/assets/images/home/dr/img1.png",
      category: "General Physician",
      name: "Dr. Amit Sharma",
      hospital: "City Care Hospital, Pune",
      price: "767",
    },
  ];

  const dispatch = useDispatch();

  const similarDoctors = useSelector((state) => state.doctor.similarDoctors);

  useEffect(() => {
    dispatch(
      getAllSimilarDoctors({
        category_id,
        user_id,
      }),
    );
  }, [dispatch, user_id]);

  console.log({ similarDoctors });

  return (
    <section className="All_Time_Fav HealthcareProducts-section ">
      <div className="container">
        <div className="heading">
          {" "}
          <h4 className="heading_text">Similar Doctors</h4>
        </div>

        <div className="all_prods_holder">
          <Swiper
            className="mySwiper"
            onSwiper={(swiper) => setSwiperInstance(swiper)}
            loop={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            modules={[Pagination, Navigation, Autoplay]}
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 15 },
              576: { slidesPerView: 2, spaceBetween: 15 },
              768: { slidesPerView: 2, spaceBetween: 20 },
              992: { slidesPerView: 3, spaceBetween: 20 },
              1200: { slidesPerView: 4, spaceBetween: 20 },
            }}
          >
            {similarDoctors?.map((item) => (
              <SwiperSlide key={item.id}>
                <DoctorCard
                  item={item}
                  id={item?.id}
                  image={process.env.REACT_APP_IMG_URL + item.image}
                  category={item.category}
                  name={
                    `${item.Doctor_Detail?.doctor_code || ""} ${item.name ||
                      ""}` || ""
                  }
                  hospital={item.Doctor_Detail?.hospital_name || ""}
                  price={item.Doctor_Detail?.fees || ""}
                  similarDr={true}
                  average_rating={item?.average_rating || "0"}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default SimilarDoctors;
